import { apiRequest, ResultAPI } from 'app/requests/apiRequest';
import { serverRequest } from 'app/requests/serverRequest';
import { buildParams } from 'app/utils/pagination';
import env from '.env.json';

export const getSummary = async (slug: string, code: string) => {
  const paramsUrl = buildParams({ code });
  const result = await apiRequest(`/api/vocabularies/summary/${slug}${paramsUrl}`, 'get', {}, false, env.URL_API_NODE) as ResultAPI;
  return result.data ?? null;
};

export const findBySlug = async (slug: string, code: string) => {
  const paramsUrl = buildParams({ code });
  const result = await apiRequest(`/api/vocabularies/${slug}${paramsUrl}`, 'get', {}, false, env.URL_API_NODE) as ResultAPI;
  return result.data ?? null;
};

export const find = async (id: string, params) => {
  const paramsUrl = buildParams(params);
  const result = await apiRequest(`/api/vocabularies/find/${id}${paramsUrl}`, 'get', {}, false, env.URL_API_NODE) as ResultAPI;
  return result.data;
};

export const list = async (params, body = {}, token = '') => {
  const paramsUrl = buildParams(params);
  const result = await serverRequest(`/api/vocabularies${paramsUrl}`, 'post', token, body, env.URL_API_NODE) as ResultAPI;
  return result.data;
};

export const total = async (locale: string) => {
  const count = await apiRequest(`/api/vocabularies/total?code=${locale}`, 'get', {}, false, env.URL_API_NODE);
  return count as number;
};
